import { CardPanel, Col, Row } from "react-materialize";
import { Benefit } from "./Benefit";
import certificate from "../../Assets/1002717-mobile.jpg"

import styles from "./Benefit.module.scss";

export const Benefits = () => {
  return (
    <div className={styles.benefits__wrapper}>
      <div className="center-align blue-grey darken-3">
        <h5 className={styles.benefits__header}>Возможности PSYCards</h5>
      </div>
      <h5 className={styles.benefits__text}>
        <Row>
          <Col m={12} s={12}>
            <CardPanel className="blue-grey darken-1">
              <span className="white-text">
                Проведение консультаций с использованием МАК
              </span>
            </CardPanel>
            <CardPanel className="blue-grey darken-1">
              <span className="white-text">Ведение трансформационных игр</span>
            </CardPanel>
            <CardPanel className="blue-grey darken-1">
              <span className="white-text">Организация коучинговых сессий</span>
            </CardPanel>
            <CardPanel className="blue-grey darken-1">
              <span className="white-text">
                Работа с таро и гадальными картами
              </span>
            </CardPanel>
            <CardPanel className="blue-grey darken-1">
              <span className="white-text">
                Работа с клиентом в Яндекс Телемост / МТС Линк / ТруКонф / ВК Тимс / ИВА ВКС / Макс
              </span>
            </CardPanel>
            <CardPanel className="blue-grey darken-1">
              <span className="white-text">
                Приглашение клиента в сессию (версия 2.0)
              </span>
            </CardPanel>
          </Col>
        </Row>
      </h5>
      <div className="video-container container">
        <iframe
          width="560"
          height="315"
          src="https://rutube.ru/play/embed/video/1accafe258e3983dab5b0037ad83be11/"
          title="RuTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        ></iframe>
      </div>
      <div className="center-align blue-grey darken-3">
        <h5 className={styles.benefits__header}>Достоинства PSYCards</h5>
      </div>
      <div className="container center-align">
        <Row>
          <Benefit num={0} startX={-600} startY={-75} endX={0} endY={0} />
          <Benefit num={1} startX={600} startY={-75} endX={0} endY={0} />
        </Row>
        <Row className={styles.benefits__wrapper}>
          <Benefit num={2} startX={-600} startY={0} endX={0} endY={0} />
          <Benefit num={3} startX={600} startY={0} endX={0} endY={0} />
        </Row>
      </div>
      <blockquote className={styles.benefits__pdf}>
        <a
          className="grey-text text-darken-3 center"
          target="blank"
          href="https://drive.google.com/file/d/1lDBLKnb2_Yso2A7g92Py6vROrNpdpasu/view?usp=drivesdk"
        >
          Инструкции PSYCards 2.0
        </a>
      </blockquote>
      <div className="center-align blue-grey darken-3">
        <h5 className={styles.benefits__header}>Свидетельство о регистрации</h5>
      </div>
      <img
        className={styles.benefits__img}
        // className="certificate"
        alt="Свидетельство о регистрации ТЗ"
        src={certificate}
      // style={{ display: 'block', margin: "0 auto" }}
      />
    </div>
  );
};
